(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  // Clean up section rendering params that break full-page loads on refresh
  if (url.searchParams.has('section_id') || url.searchParams.has('sections') || url.searchParams.has('sections_url')) {
    const cleaned = new URL(url.toString());
    cleaned.searchParams.delete('section_id');
    cleaned.searchParams.delete('sections');
    cleaned.searchParams.delete('sections_url');
    // Also drop stray variant param on collection pages
    cleaned.searchParams.delete('variant');
    if (cleaned.toString() !== url.toString()) {
      window.location.replace(cleaned.toString());
    }
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // If user loads a paginated URL (e.g., ?page=2), scroll to results top
  if (url.searchParams.get('page')) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const target = document.getElementById('ResultsList');
        if (!target) return;
        const previousTabIndex = target.getAttribute('tabindex');
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        const top = target.getBoundingClientRect().top + window.scrollY - 8;
        window.scrollTo({ top, behavior: 'instant' });
        if (previousTabIndex === null) target.removeAttribute('tabindex');
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
